import styled from 'styled-components';

import { RadiusConfig, neutral, neutralTrans, primary } from 'enable-ui';

export const StyledPaginationContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  ul {
    display: flex;
    align-items: center;
    list-style: none;
    padding: 0;
    margin: 12px 0px 12px 0px;
    width: fit-content;
  }
  .active a {
    background: #fd8a241a !important;
    color: #fd8a24 !important;
  }

  .page-item a {
    font-size: 18px;
    font-weight: 600;
    line-height: 26px;
    cursor: pointer;
    height: 32px;
    color: #808080;
    min-width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px 12px;
    border-radius: ${RadiusConfig.sm}px;
    :hover {
      color: ${neutral['neutral-10']};
      background-color: ${neutral['neutral-4']};
    }
    :active {
      color: ${neutral['neutral-10']};
      background-color: ${neutral['neutral-5']};
    }
  }
  .break {
    min-width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .break a {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: ${neutral['neutral-7']};
    :hover {
      color: ${neutral['neutral-10']};
    }
  }
  .previous button {
    margin-right: 4px;
    background-color: transparent;
    svg path {
      stroke: #808080;
    }
  }
  .next button {
    margin-left: 4px;
    background-color: transparent;
    svg path {
      stroke: #808080;
    }
  }
  .disabled button {
    background-color: transparent;
    svg path[stroke] {
      stroke: ${neutralTrans['neutralTrans-25']};
    }
    svg path[fill] {
      fill: ${neutralTrans['neutralTrans-25']};
    }
    :hover {
      background-color: ${neutral['neutral-1']};
    }
    :active {
      background-color: ${neutral['neutral-1']};
    }
  }

  .dropdown-children {
    div {
      height: 32px;
      padding: 10px 8px;
      border-radius: 12px;
      width: auto !important;
    }

    p {
      color: #222222;
      font-size: 18px;
      line-height: 26px;
    }
  }
`;

export const StyledPaginationButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: ${RadiusConfig.xs}px;
  background-color: ${neutral['neutral-1']};
  cursor: pointer;
  outline: none;
  padding: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  :hover {
    background-color: ${neutral['neutral-4']};
    svg path[stroke] {
      stroke: ${neutral['neutral-10']};
    }
    svg path[fill] {
      fill: ${neutral['neutral-10']};
    }
  }
  :active {
    background-color: ${neutral['neutral-5']};
    svg path[stroke] {
      stroke: ${neutral['neutral-10']};
    }
    svg path[fill] {
      fill: ${neutral['neutral-10']};
    }
  }
`;
